import {View} from 'react-native';
import React from 'react';
import {NotificationStatus} from '../../../../shared/models/profile/notification';
import {images} from '../../../../assets/icons';
import {dateFormats} from '../../../../shared/constants/date';
import {ViewProps} from './model';
import {datePipe} from '../../../../shared/pipes';
import {Screens} from '../../../../shared/routing';
import {useNavigation, useRoute} from '@react-navigation/native';
import {Text} from '../../../../shared/components/text';
import {LoadableContent} from '../../../../shared/components/loadableContent';
import {Link} from '../../../../shared/components/link';
import {GetMobileStyles} from './style';

export default ({notifications, baseItemScreen, hideBottomLine}: ViewProps) => {
  const nav = useNavigation();
  const route = useRoute();
  const styles = GetMobileStyles();

  const screen = route.name === Screens.Main ? Screens.Main : Screens.NotificationsMenu;

  return (
    <View style={styles.container}>
      <LoadableContent loading={!notifications}>
        {notifications?.map((notification, i) => {
          const isRead = NotificationStatus.Read === notification.statusId;
          return (
            <Link
              testID={`notification-row-${i}`}
              key={notification.id ?? i}
              navigate={nav.navigate}
              screenParams={{
                screen,
                params: {
                  screen: baseItemScreen ?? Screens.NotificationsItem,
                  params: {
                    id: notification.id || '',
                    title: notification.topic ?? 'Уведомление',
                  },
                },
              }}
              screen={Screens.MainTabs}>
              <View
                testID={`mobile-notification-common-${i}-id`}
                style={[styles.item, hideBottomLine && i === notifications.length - 1 && {borderBottomWidth: 0}]}>
                <View style={[styles.itemContent]}>
                  <View style={styles.iconWrapper}>
                    <View testID={`mobile-notification-${isRead ? 'read' : 'unread'}-label-${i}`} style={styles.icon}>
                      {isRead ? (
                        <images.NotCheckRound
                          width={styles.icon.width}
                          height={styles.icon.height}
                          color={styles.icon.color}
                        />
                      ) : (
                        <images.CheckRound
                          width={styles.icon.width}
                          height={styles.icon.height}
                          color={styles.icon.color}
                        />
                      )}
                    </View>
                  </View>
                  <View style={[styles.itemTextWrapper]}>
                    <Text
                      testID={`mobile-notification-item-topic-${i}-id`}
                      style={isRead ? styles.itemText : styles.itemTextNotRead}>
                      {notification.topic}
                    </Text>
                  </View>
                </View>
                <View style={[styles.itemDateTimeWrapper]}>
                  <Text testID={`mobile-notification-item-date-${i}-id`} style={styles.itemDateTime} numberOfLines={1}>
                    {datePipe(notification.dateTime, dateFormats.fullDateWithTime)}
                  </Text>
                </View>
              </View>
            </Link>
          );
        })}
      </LoadableContent>
    </View>
  );
};
